// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
   border: 4px solid var(--error) !important;
}

#toast-container {
   position: absolute;
   bottom: 24px;
   right: 24px;

   min-height: 3em;
   width: 25vw;
   min-width: 300px;

   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-content: center;

   padding: var(--padding);

   border: 4px solid var(--deep-teal);
   border-radius: var(--border-radius);
   background-color: var(--frame-bg);
}

#toast-container svg {
   height: 1em;
   width: 1em;
}

#toast-container button {
   padding: 0px;
   border: none;
   background: none;
   height: 2em;
   width: 2em;
}

#toast-container button:hover {
   background-color: var(--button-primary-hovered);
}

#toast-container .toast-message-body {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-content: center;
   padding: 0;
   width: 75%;
   background-color: unset;
}

.toast-message-header {
   display: flex;
   align-items: center;
   padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/Toasts/ECLToast.css"],"names":[],"mappings":"AAAA;GACG,yCAAyC;AAC5C;;AAEA;GACG,kBAAkB;GAClB,YAAY;GACZ,WAAW;;GAEX,eAAe;GACf,WAAW;GACX,gBAAgB;;GAEhB,aAAa;GACb,mBAAmB;GACnB,8BAA8B;GAC9B,qBAAqB;;GAErB,uBAAuB;;GAEvB,kCAAkC;GAClC,mCAAmC;GACnC,iCAAiC;AACpC;;AAEA;GACG,WAAW;GACX,UAAU;AACb;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,gBAAgB;GAChB,WAAW;GACX,UAAU;AACb;;AAEA;GACG,+CAA+C;AAClD;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,qBAAqB;GACrB,UAAU;GACV,UAAU;GACV,uBAAuB;AAC1B;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,kBAAkB;AACrB","sourcesContent":[".error {\r\n   border: 4px solid var(--error) !important;\r\n}\r\n\r\n#toast-container {\r\n   position: absolute;\r\n   bottom: 24px;\r\n   right: 24px;\r\n\r\n   min-height: 3em;\r\n   width: 25vw;\r\n   min-width: 300px;\r\n\r\n   display: flex;\r\n   flex-direction: row;\r\n   justify-content: space-between;\r\n   align-content: center;\r\n\r\n   padding: var(--padding);\r\n\r\n   border: 4px solid var(--deep-teal);\r\n   border-radius: var(--border-radius);\r\n   background-color: var(--frame-bg);\r\n}\r\n\r\n#toast-container svg {\r\n   height: 1em;\r\n   width: 1em;\r\n}\r\n\r\n#toast-container button {\r\n   padding: 0px;\r\n   border: none;\r\n   background: none;\r\n   height: 2em;\r\n   width: 2em;\r\n}\r\n\r\n#toast-container button:hover {\r\n   background-color: var(--button-primary-hovered);\r\n}\r\n\r\n#toast-container .toast-message-body {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   align-content: center;\r\n   padding: 0;\r\n   width: 75%;\r\n   background-color: unset;\r\n}\r\n\r\n.toast-message-header {\r\n   display: flex;\r\n   align-items: center;\r\n   padding-left: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
